import { Link } from "react-router-dom";
import { categoryMeta, categoryOrder, getMediaByCategory } from "@/lib/media";

export default function CategoryEntry() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
      {categoryOrder.map((key) => {
        const meta = categoryMeta[key];
        const items = getMediaByCategory(key);
        const featured = items[0];
        const accentClasses =
          meta.accent === "primary"
            ? "bg-primary-100 text-primary-700"
            : meta.accent === "accent"
              ? "bg-accent-100 text-accent-700"
              : "bg-secondary-100 text-secondary-900";
        return (
          <Link
            key={key}
            to={`/category/${key}`}
            className="group relative flex items-center gap-4 p-5 rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-400/60 transition-colors cursor-pointer"
          >
            <span className={`w-14 h-14 rounded-lg flex items-center justify-center shrink-0 ${accentClasses}`}>
              <i className={`${meta.icon} text-2xl`} />
            </span>
            <div className="min-w-0">
              <h3 className="font-heading font-bold text-lg text-foreground-950 group-hover:text-primary-400 transition-colors">
                {meta.title}
              </h3>
              <p className="mt-1 text-xs text-foreground-500 line-clamp-1">
                共 {items.length} 部 · {featured ? featured.title : "暂无内容"}
              </p>
            </div>
            <i className="ri-arrow-right-line ml-auto text-xl text-foreground-500 group-hover:text-primary-400 group-hover:translate-x-1 transition-all shrink-0" />
          </Link>
        );
      })}
    </div>
  );
}